class HubspotForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('form');
        this.submit = this.querySelector('button');
        this.url = this.dataset.url;
        this.submit.addEventListener('click', this.handleForm.bind(this))
    }
    
    async handleForm(e) {
        e.preventDefault();
        if(!this.url) return 

        if(!this.form.checkValidity()) {
            this.form.reportValidity();
            return;
        }
        const fields = this.getFields();
    
        if(!fields) return
        const config = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        }
        config.body = JSON.stringify({fields});
        try{
            await fetch(this.url, config);
        } catch(e) {
            throw e;
        }
            
    }
    getFields() {
    const formData = new FormData(this.form);
    const arr = [];
    for (const [key, value] of formData.entries()) {

            if(key == 'fullname' ) {
                const [firstName, lastName] = value.split(' ');
                lastName ? arr.push({ name:"firstname", value: firstName}, { name:"lastname", value: lastName}) : arr.push({ name:"firstname", value: firstName})
            } else {
                arr.push({ name:key, value: value})
            }
    }

    return arr;
    }
}
customElements.define('hubspot-form', HubspotForm);